import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import api from './api';
import Landing from './tabs/Landing/Landing';
import NextLocalMatch from './tabs/NextLocalMatch/NextLocalMatch';
import NextAwayMatch from './tabs/NextAwayMatch/NextAwayMatch';
import Fixture from './tabs/Fixture/Fixture';
import Announcements from './tabs/Announcements/Announcements';
import Notifications from './tabs/Notifications/Notifications';
import Users from './tabs/Users/Users';
import BusStop from './tabs/BusStop/BusStop';
import Payments from './tabs/Payments/Payments';
import Clothing from './tabs/Clothing/Clothing';
import PaymentResult from './pages/PaymentResult';
import Navbar from './navbar/Navbar';
import EnvBanner from './components/EnvBanner';
import "react-datepicker/dist/react-datepicker.css";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem('isAuthenticated') === 'true');
  const [showLoginDialog, setShowLoginDialog] = useState(() => localStorage.getItem('isAuthenticated') !== 'true');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
    setShowLoginDialog(true);
  };

  const handleLogin = async () => {
    try {
      const response = await api.post('/api/v1/auth/login', { email, password });
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('isAuthenticated', 'true');
      setIsAuthenticated(true);
      setShowLoginDialog(false);
    } catch (error) {
      alert('Usuario o contraseña incorrectos');
    }
  };

  return (
    <Router>
      {/* Fuera de <Routes> a proposito: tiene que verse tambien en el login y
          en las paginas publicas de resultado de pago. */}
      <EnvBanner />
      <Routes>
        {/* Public routes — payment result pages */}
        <Route path="/pago-exitoso" element={<PaymentResult type="success" />} />
        <Route path="/pago-fallido" element={<PaymentResult type="failure" />} />
        <Route path="/pago-pendiente" element={<PaymentResult type="pending" />} />

        {/* All other routes — require authentication */}
        <Route
          path="*"
          element={
            <>
              {showLoginDialog && (
                <div style={modalStyle}>
                  <div style={modalContentStyle}>
                    <h3>Peña Roja La Plata ADMIN</h3>
                    <input
                      type="text"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={inputStyle}
                    />
                    <input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={inputStyle}
                    />
                    <button onClick={handleLogin} style={buttonStyle}>Login</button>
                  </div>
                </div>
              )}
              {isAuthenticated && (
                <>
                  <Navbar onLogout={handleLogout} />
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/next-local-match" element={<NextLocalMatch />} />
                    <Route path="/next-away-match" element={<NextAwayMatch />} />
                    <Route path="/fixture" element={<Fixture />} />
                    <Route path="/announcements" element={<Announcements />} />
                    <Route path="/notifications" element={<Notifications />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/bus-stop" element={<BusStop />} />
                    <Route path="/payments" element={<Payments />} />
                    <Route path="/clothing" element={<Clothing />} />
                  </Routes>
                </>
              )}
            </>
          }
        />
      </Routes>
    </Router>
  );
};

const modalStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  textAlign: 'center',
};

const inputStyle = {
  marginBottom: '10px',
  padding: '8px',
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: '4px',
};

const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: '#C73B33',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export default App;
